// frontend/src/components/auth/AuthLayout.js
import React from 'react';
import { motion } from 'framer-motion';
import './AuthLayout.css';
import logo from '../../assets/logo.png';

const AuthLayout = ({ children, title }) => {
    return (
        <div className="auth-container">
            <motion.div
                className="auth-card"
                initial={{opacity: 0, y: -20}}
                animate={{opacity: 1, y: 0}}
                transition={{duration: 0.5}}
            >
                <div className="logo-title-container">
                    <img src={logo} alt="NeuroTrader Logo" className="logo-image"/>
                    <h1 className="auth-title">NeuroTrader</h1>
                </div>
                <h2 className="auth-subtitle">{title}</h2>
                {children}
            </motion.div>
            <footer className="auth-disclaimer">

            </footer>
        </div>

    );
};
export default AuthLayout;